/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Potřebuji nabídku`
};

const da_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg har brug for et tilbud`
};

const de_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Ich benötige ein Angebot`
};

const en_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `I need a quote`
};

const es_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Necesito un presupuesto`
};

const fr_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `J'ai besoin d'un devis`
};

const hu_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Szüksége van egy ajánlatra`
};

const it_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Ho bisogno di un preventivo`
};

const nl_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Ik heb een offerte nodig`
};

const pl_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Potrzebuję wyceny`
};

const pt_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Preciso de um orçamento`
};

const sv_contact_other_subjects_quote = /** @type {(inputs: {}) => string} */ () => {
	return `Jag behöver en offert`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_other_subjects_quote = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_other_subjects_quote(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_other_subjects_quote", locale)
	if (locale === "cs") return cs_contact_other_subjects_quote(inputs)
	if (locale === "da") return da_contact_other_subjects_quote(inputs)
	if (locale === "de") return de_contact_other_subjects_quote(inputs)
	if (locale === "en") return en_contact_other_subjects_quote(inputs)
	if (locale === "es") return es_contact_other_subjects_quote(inputs)
	if (locale === "fr") return fr_contact_other_subjects_quote(inputs)
	if (locale === "hu") return hu_contact_other_subjects_quote(inputs)
	if (locale === "it") return it_contact_other_subjects_quote(inputs)
	if (locale === "nl") return nl_contact_other_subjects_quote(inputs)
	if (locale === "pl") return pl_contact_other_subjects_quote(inputs)
	if (locale === "pt") return pt_contact_other_subjects_quote(inputs)
	return sv_contact_other_subjects_quote(inputs)
};
export { contact_other_subjects_quote as "contact.other_subjects.quote" }